import { Breakpoints } from '@apps/gated-2021/breakpoints';
import { Colors } from '@src/colors';
import styled from 'styled-components';
import {
    Input as FormInput,
    Subtitle as FormSubtitle,
    Title as FormTitle,
} from '../components/form.styled';

export const Title = styled(FormTitle)``;

export const Subtitle = styled(FormSubtitle)`
    display: flex;
    gap: 29px;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        flex-direction: column;
        text-align: center;
        align-items: center;
        gap: 25px;
    }
`;

export const Input = styled(FormInput)`
    display: flex;
    flex-direction: column;
    gap: 38px;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        flex-direction: column;
        text-align: center;
        align-items: center;
        gap: 32px;
    }
`;

export const Paragraph = styled.p`
    color: white;
    font-family: 'Public Sans';
    font-size: 20px;
    line-height: 29px;
    letter-spacing: -0.2px;
    text-align: left;
    margin: 0;

    @media screen and (max-width: ${Breakpoints.mobile}) {
        text-align: center;
    }

    @media print {
        color: ${Colors.midnight};
    }
`;
